import { useState } from 'react';
import { motion } from 'framer-motion';
import { FUNNEL_STEPS } from '@/lib/homeData';
import { AhaToastMockup, BuyerHandoffMockup, CheckoutMockup, MobileSellerMockup } from '@/components/home/FintechMockups';

export default function FunnelDemoSection() {
  const [activeStep, setActiveStep] = useState(0);

  return (
    <section className="bg-slate-950 px-6 py-20 md:py-24 text-slate-100">
      <div className="container mx-auto max-w-6xl">
        <div className="max-w-3xl">
          <p className="text-xs font-semibold uppercase tracking-[0.14em] text-slate-400">How it works</p>
          <h2 className="mt-3 text-3xl font-bold text-white md:text-4xl">Type the amount. Hit send. You&apos;re done.</h2>
          <p className="mt-4 text-slate-300">Walk the exact sales flow your reps use in the field, with no portals and no friction.</p>
        </div>

        <div className="mt-10 grid items-start gap-8 lg:grid-cols-[0.95fr_1.05fr]">
          <div className="space-y-3">
            {FUNNEL_STEPS.slice(0, 3).map((step, idx) => (
              <motion.button
                key={step.title}
                type="button"
                onClick={() => setActiveStep(idx)}
                whileHover={{ y: -2 }}
                className={`w-full rounded-2xl border p-5 text-left transition ${
                  activeStep === idx
                    ? 'border-emerald-300 bg-emerald-400/10 shadow-[0_18px_45px_-30px_rgba(16,185,129,0.85)]'
                    : 'border-slate-800 bg-slate-900/60 hover:border-slate-600'
                }`}
              >
                <div className="flex items-center justify-between">
                  <span className="text-xs font-semibold uppercase tracking-[0.14em] text-slate-400">Step {idx + 1}</span>
                  <span className="rounded-full bg-slate-800 px-2.5 py-1 text-xs font-medium text-slate-200">{step.metric}</span>
                </div>
                <h3 className="mt-3 text-xl font-semibold text-white">{step.title}</h3>
                <p className="mt-1 text-sm text-slate-300">{step.detail}</p>
              </motion.button>
            ))}
          </div>

          <motion.div
            key={activeStep}
            initial={{ opacity: 0, y: 10, scale: 0.99 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            transition={{ duration: 0.25 }}
            className="rounded-[2rem] border border-slate-800 bg-slate-900/70 p-4 md:p-6"
          >
            {activeStep === 0 && <MobileSellerMockup />}
            {activeStep === 1 && <BuyerHandoffMockup />}
            {activeStep === 2 && (
              <div className="space-y-4">
                <CheckoutMockup />
                <AhaToastMockup />
              </div>
            )}
          </motion.div>
        </div>
      </div>
    </section>
  );
}
